enum DrawerUid {
  Vitals = "vitals",
  Differential = "differential",
  Workup = "workup",
  Diagnosis = "diagnosis",
  Outcomes = "outcomes",
  Care = "care",
  Keypoints = "keypoints",
  Sponsor = "sponsor",
  OriginalVideo = "original_video",
}

export function isDrawerUid(value: string): value is DrawerUid {
  return Object.values(DrawerUid).includes(value as DrawerUid);
}

export const SCHEDUABLE_SECTION_UIDS = [
  DrawerUid.Vitals,
  DrawerUid.Differential,
  DrawerUid.Workup,
  DrawerUid.Diagnosis,
  DrawerUid.Outcomes,
  DrawerUid.Care,
  DrawerUid.Keypoints,
];
